import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { AbstractPageFooterColumnComponent } from '../../abstract-page-footer-column.component';
import { NPageFooter } from '../../page-footer.interface';

@Component({
    selector: 'page-footer-column-mobile',
    templateUrl: './page-footer-column-mobile.component.html',
    styleUrl: './page-footer-column-mobile.component.scss',
    host: {
        '[style.background-color]': 'column.accordionBackgroundColor || null'
    },
    standalone: true,
    imports: [HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterColumnMobileComponent extends AbstractPageFooterColumnComponent {
    @Input({ required: true })
    override column!: NPageFooter.IPageFooterColumnMobile;

    @Input()
    index = 0;
}
